@if (years().length > 1) {
  <div class="mb-4">
    <span class="mb-1 block text-xs text-greyscale-500">{{
      "travelBoard.period" | transloco
    }}</span>
    <p-selectbutton
      [options]="years()"
      [(ngModel)]="selectedYear"
      optionValue="value"
      size="small"
    >
      <ng-template let-item pTemplate="item">
        <span>{{
          item.value === 0 ? ("export.allTrips" | transloco) : item.label
        }}</span>
        <span
          [class]="
            selectedYear === item.value
              ? 'text-primary-400'
              : 'text-greyscale-400'
          "
          >({{ item.count }})</span
        >
      </ng-template>
    </p-selectbutton>
  </div>
}
<div class="grid grid-cols-2 gap-4 md:grid-cols-4">
  <app-stats-card
    [value]="stats.totalTrips === 0 ? '—' : stats.totalTrips.toString()"
    [label]="'travelBoard.stats.trips' | transloco"
    [useGreentripperLogo]="true"
  />
  <app-stats-card
    [value]="
      stats.totalEmissions === 0 ? '—' : (stats.totalEmissions | formatCO2e)
    "
    [label]="'travelBoard.stats.totalEmissions' | transloco"
    icon="cloud"
  />
  <app-stats-card
    [value]="stats.totalTravelers === 0 ? '—' : stats.totalTravelers.toString()"
    [label]="'travelBoard.stats.travelers' | transloco"
    icon="users"
  />
  <app-stats-card
    [value]="
      stats.avgImpactPerTraveller > 0
        ? (stats.avgImpactPerTraveller | formatCO2e)
        : '—'
    "
    [label]="'travelBoard.stats.avgImpactPerTraveller' | transloco"
    icon="leaf"
  />
</div>
